import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCalendarComponent } from "./med-icon-calendar.component";

@NgModule({
  declarations: [
    MedIconCalendarComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCalendarComponent,
  ],
})
export class MedIconCalendarModule { }
